import * as React from 'react';

export interface IApiClient {
	baseUrl: string;
}

export class ApiClient implements IApiClient {
	public baseUrl: string;

	constructor({ baseUrl }: { baseUrl: string }) {
		this.baseUrl = baseUrl;
	}
}

export interface IApiClientContext {
	apiClient: ApiClient;
}

export const ApiClientContext = React.createContext<IApiClientContext>(null);

export const useApiClientContext = () => {
	const context = React.useContext(ApiClientContext);
	if (!context) {
		throw new Error('This component required the use of "ApiClientContext"');
	}
	return context;
};

export const ApiClientContextProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
	const context = React.useRef<IApiClientContext>({
		apiClient: new ApiClient({ baseUrl: import.meta.env.VITE_API_URL }),
	}).current;
	return <ApiClientContext.Provider value={context}>{children}</ApiClientContext.Provider>;
};
